import React, {useState, useCallback} from 'react';
import {DebounceInput} from 'react-debounce-input';
import { useDispatch } from 'react-redux';
import onClickOutside from 'react-onclickoutside';

import {detectIconById} from '../../common/enum'
import {
    getPlayers
} from '../../actions/leader-board';
import './styles.scss';

function SearchPlayerComplete(props) {
    const {placeholder, onPlayerClick} = props;

    const dispatch = useDispatch();

    const [suggestions, setSuggestions] = useState([]);
    const [toggle, setToggle] = useState(false);

    const onSearch = useCallback(async (value) => {
        try {
            const result = await dispatch(getPlayers({
                keyword: value,
            }));
            setSuggestions(result);
            setToggle(true);
        }catch (e) {
            setSuggestions([]);
        }
    }, []);

    SearchPlayerComplete.handleClickOutside = useCallback(() => {
        setToggle(false);
    }, []);

    return <div style={{ position: 'relative' }} className={'search-autocomplete-dsa'}>
        <div>
            <img alt="search" src="/img/ic_search_top_svg.svg" />
            <DebounceInput
                className="dsa-input"
                style={{outline: 'none'}}
                onFocus={(e) => {
                    if(!e.target.value) {
                        return;
                    }
                    setToggle(true);
                }}
                placeholder={placeholder}
                minLength={0}
                debounceTimeout={300}
                onChange={e => {
                    if(!e.target.value) {
                        setToggle(false);
                        return;
                    }
                    onSearch(e.target.value);
                }} 
            />
            {
                toggle &&
                        <div className="dropdown" style={{width: 250, maxHeight: 250, marginTop: 3}}>
                            {
                                suggestions.map((value, key) => {
                                    return (
                                        <div key={key} className="items" style={{paddingLeft: 15, width: '100%'}} onClick={() => {
                                            onPlayerClick(value);
                                            setToggle(false);
                                        }}>
                                            <img style={{position: 'inherit'}} src={detectIconById(value.team.id)} alt="team-name" />
                                            <span className="text">{value.player_name}</span>
                                            <span style={{color: '#74818A', fontSize: 13}}>{value.uniform_number}</span>
                                        </div>
                                    )
                                })}
                        </div>
            }
        </div>
    </div>
}

const clickOutsideConfig = {
    handleClickOutside: () => SearchPlayerComplete.handleClickOutside
};

export default onClickOutside(SearchPlayerComplete, clickOutsideConfig);
